import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'school-space-client/components';

import constanst from '../../../constanst';

import './DocumentProgressBar.css';

const DocumentProgressBar = ({ supportingDocuments, customerDeposits }) => {
    const isRiskDocUploaded = supportingDocuments.filter(
        item => item.documentType === constanst.documentTypeConst.riskAssessment
    );
    const isSafeGaurdingPolicyUploaded = supportingDocuments.filter(
        item => item.documentType === constanst.documentTypeConst.safeGaurdingPolicy
    );

    const isLiabilityInsuranceUploaded = supportingDocuments.filter(
        item => item.documentType === constanst.documentTypeConst.liabilityInsurance
    );
    if (
        isRiskDocUploaded.length === 0 ||
        isSafeGaurdingPolicyUploaded.length === 0 ||
        isLiabilityInsuranceUploaded.length === 0 ||
        customerDeposits === null
    ) {
        return (
            <div className="lets-block">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex">
                        <div className="danger-img">
                            <img src="images/dangerIcon.svg" alt="danger" />
                        </div>
                        <div className="">
                            <p className="letsmsg">
                                Please remember to upload your supporting information.
                            </p>
                        </div>
                    </div>
                    <div className="lets-do-it">
                        <button className="btn btnlets" type="button">
                            <Link url="/supporting-information">Let’s do it!</Link>
                        </button>
                    </div>
                </div>
                {supportingDocuments.length > 0 && (
                    <div className="d-flex justify-content-between progress-sec mt-3">
                        <div className="progressbar">
                            <div className={isRiskDocUploaded.length > 0 ? 'bar active' : 'bar'} />
                            <div className="">
                                <p
                                    className={
                                        isRiskDocUploaded.length > 0
                                            ? 'progresstitle active'
                                            : 'progresstitle'
                                    }
                                >
                                    {isRiskDocUploaded.length > 0 && (
                                        <img
                                            src="images/tick.png"
                                            alt="tick"
                                            className="document-tick"
                                        />
                                    )}
                                    Risk Assessment
                                </p>
                            </div>
                        </div>

                        <div className="progressbar active">
                            <div
                                className={
                                    isSafeGaurdingPolicyUploaded.length > 0 ? 'bar active' : 'bar'
                                }
                            />
                            <div className="">
                                <p
                                    className={
                                        isSafeGaurdingPolicyUploaded.length > 0
                                            ? 'progresstitle active'
                                            : 'progresstitle'
                                    }
                                >
                                    {isSafeGaurdingPolicyUploaded.length > 0 && (
                                        <img
                                            src="images/tick.png"
                                            alt="tick"
                                            className="document-tick"
                                        />
                                    )}
                                    Safeguarding Policy
                                </p>
                            </div>
                        </div>
                        <div className="progressbar active">
                            <div
                                className={
                                    isLiabilityInsuranceUploaded.length > 0 ? 'bar active' : 'bar'
                                }
                            />
                            <div className="">
                                <p
                                    className={
                                        isLiabilityInsuranceUploaded.length > 0
                                            ? 'progresstitle active'
                                            : 'progresstitle'
                                    }
                                >
                                    {isLiabilityInsuranceUploaded.length > 0 && (
                                        <img
                                            src="images/tick.png"
                                            alt="tick"
                                            className="document-tick"
                                        />
                                    )}
                                    Proof of Public Liability Insurance
                                </p>
                            </div>
                        </div>
                        <div className="progressbar active">
                            <div className={customerDeposits !== null ? 'bar active' : 'bar'} />
                            <div className="">
                                {customerDeposits !== null && (
                                    <img
                                        src="images/tick.png"
                                        alt="tick"
                                        className="document-tick"
                                    />
                                )}
                                <p
                                    className={
                                        customerDeposits !== null
                                            ? 'progresstitle active'
                                            : 'progresstitle'
                                    }
                                >
                                    Deposit
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    return <div />;
};

DocumentProgressBar.defaultProps = {
    customerDeposits: null
};

DocumentProgressBar.propTypes = {
    supportingDocuments: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            customerId: PropTypes.string,
            name: PropTypes.string,
            documentType: PropTypes.string,
            approvalStatus: PropTypes.bool,
            expiryDate: PropTypes.string,
            documentUrl: PropTypes.string
        })
    ).isRequired,
    customerDeposits: PropTypes.shape({
        id: PropTypes.string,
        customerId: PropTypes.string,
        amount: PropTypes.number,
        refundStatus: PropTypes.bool
    })
};

export default DocumentProgressBar;
